<template lang="pug">
.split-point-select
  form(@submit.prevent="submit()")
    .form-group
        label.light(for="split-point-code-input") End code
        .input-group
          input#split-point-code-input.form-control(v-model="spCode")
          .input-group-btn
            button.btn.btn-default(type='submit') Select
            button.btn.btn-default.dropdown-toggle(type='button', data-toggle='dropdown')
              span.caret
            ul.dropdown-menu.dropdown-menu-right
              li
                a(@click="updateSpCode(rollLastCode)") To the end of the roll
              li
                a(@click="updateSpCode(findRollCode)") Use code from find roll
</template>
<script>
import Util from '@/service/Util'

export default {
  props: ['rollLastCode', 'findRollCode', 'code'],
  mounted() {
    this.$el.querySelector('#split-point-code-input').focus()
  },
  data() {
    return {
      spCode: this.code || ''
    }
  },
  methods: {
    updateSpCode(code) {
      this.spCode = code
      this.submit()
    },
    submit() {
      this.$emit('submit', Util.removeUrl(this.spCode))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/activator/components/SplitPointSelect.vue